$(document).ready(function(){
    $('.go-to-payment').on('click', function(e){
        e.preventDefault();
        $(this).fadeOut(1501);
        $('.checkout-right .summary .shop_table').fadeToggle(500);
        $('.checkout-right .summary h3').html('Płatność');
        setTimeout(function(){
            $('.checkout-right .summary #payment').fadeToggle(1000);
        }, 501)
    });

});